
const translations = {
  zh: {
    navbar: {
      home: '首頁',
      about: '關於我們',
      services: '服務項目',
      whyUs: '為什麼選擇我們',
      showcase: '成功案例',
      contact: '聯絡我們'
    },
    hero: {
      title: '從物理基建到雲端架構',
      subtitle: '為您的企業打造',
      highlight: '堅不可摧的數位基石',
      description: '我們結合頂級結構化佈線工程與前瞻性 IT 基礎設施規劃，輔以全天候受管理服務，確保您的企業通訊永不中斷，靈活應對未來擴展。',
      cta: '立即預約現場勘查',
      learnMore: '瀏覽基礎設施方案'
    },
    about: {
      badge: 'ABOUT US',
      title: '物理層面的工藝',
      titleItalic: '數位時代的遠見',
      p1: '我們深知強大的企業發展始於穩固的基礎。作為 IT 綜合服務的領航者，我們不僅是技術供應商，更是您數位基石的建築師。',
      p2: '我們專精於將複雜的結構化佈線系統轉化為高效、整潔且易於管理的通訊網路。從物理線纜的精準鋪設，到IT 基礎設施的戰略規劃，再到全方位的受管理 IT 服務，我們提供端到端的解決方案。',
      whyTitle: '為什麼選擇我們？',
      points: [
        { label: '工程卓越：', text: '嚴格遵循國際佈線標準，確保每一條線纜、每一個機櫃都能發揮極致效能。' },
        { label: '前瞻規劃：', text: '我們不只解決今天的問題，更為您未來的 5-10 年擴展預留空間。' },
        { label: '無縫維運：', text: '透過主動式監控，我們在問題發生前就將其排除。' }
      ],
      tags: ['工程卓越', '前瞻規劃', '無縫維運'],
      stats: {
        projects: '專案經驗',
        uptime: '系統上線率',
        support: '全天候支援'
      }
    },
    servicesSection: {
      badge: 'OUR SERVICES',
      title: '核心服務',
      subtitle: '從物理層到應用層的完整解決方案',
      items: [
        {
          title: '結構化佈線系統',
          subtitle: '企業通訊的物理命脈',
          items: [
            'Cat6/6A 及光纖網路佈線設計與施工',
            '數據中心機房規劃與理線工程',
            '無線網路存取點 (AP) 佈點與優化',
            '佈線系統測試報告與認證 (Fluke Testing)'
          ]
        },
        {
          title: 'IT 基礎設施規劃',
          subtitle: '打造穩定、高效的數位環境',
          items: [
            '伺服器與存儲系統 (Storage) 佈署',
            '企業級網路架構 (Switch/Router/Firewall) 設計',
            '雲端與本地混合架構整合',
            '機房環境監控與不斷電系統 (UPS) 配置',
            'VoIP 系統架構佈署'
          ]
        },
        {
          title: '全方位受管理 IT 服務',
          subtitle: '您的專屬外部 IT 部門',
          items: [
            '7x24 小時遠端與現場技術支援',
            '主動式網路安全監控與威脅防護',
            '系統備援、災難恢復 (DR) 與數據備份管理',
            '定期 IT 資產審計與效能優化建議'
          ]
        }
      ]
    },
    clientLogos: {
      title: '值得信賴的合作夥伴',
      subtitle: '我們為各行業的領先企業提供專業服務'
    },
    whyChooseUs: {
      title: '為什麼領先企業選擇我們？',
      subtitle: '我們不只是服務供應商，更是您業務增長的數位基石。',
      advantages: [
        {
          tag: '卓越工程',
          title: '嚴格的結構化標準',
          painPointLabel: '我們看到的痛點：',
          painPoint: '許多 IT 公司只求「連通」，導致機房線路如蜘蛛網，日後查修困難重重。',
          solutionLabel: '我們的優勢：',
          solution: '我們堅持「工藝級佈線」。每一條線纜都經過 Fluke 專業測試認證，並提供完整的標籤系統與數位化拓撲圖。這意味著您的機房不僅美觀，更能在故障發生時秒速定位。'
        },
        {
          tag: '全方位整合',
          title: '從物理層到應用層',
          painPointLabel: '我們看到的痛點：',
          painPoint: '佈線找一家、設備找一家、維護找一家，出問題時各方推諉責任（Finger-pointing）。',
          solutionLabel: '我們的優勢：',
          solution: '我們提供一站式（One-Stop）IT 解決方案。從基礎的物理佈線、伺服器架構到後續的受管理維運，我們全權負責。您只需對接一個窗口，剩下的複雜技術交給我們。'
        },
        {
          tag: '主動式維運',
          title: '在問題發生前解決它',
          painPointLabel: '我們看到的痛點：',
          painPoint: '傳統 IT 是「壞了才修」，這會導致業務中斷帶來的巨大經濟損失。',
          solutionLabel: '我們的優勢：',
          solution: '我們的 Managed IT Services 採用 24/7 主動監控系統。我們在硬體過熱、網路擁塞或安全威脅成形前，就已經完成預警與排解，將您的系統上線率維持在 99.9% 以上。'
        },
        {
          tag: '未來就緒',
          title: '具備 5-10 年的擴展遠見',
          painPointLabel: '我們看到的痛點：',
          painPoint: '基礎設施規劃不當，導致業務擴張時必須推倒重來，造成重複投資。',
          solutionLabel: '我們的優勢：',
          solution: '我們的設計具備高度擴展性（Scalability）。在規劃初期，我們就會預留頻寬餘裕與模組化空間，確保您的 IT 架構能隨著公司規模翻倍而平滑升級。'
        }
      ]
    },
    comparisonTable: {
      title: '服務對比',
      subtitle: '看看我們與一般 IT 承包商的差異',
      headers: {
        dimension: '服務維度',
        competitor: '一般 IT 承包商',
        us: '我們的專業服務'
      },
      rows: [
        {
          dimension: '佈線標準',
          competitor: '只要連通即可，缺乏系統標籤',
          us: '國際標準施工，提供認證報告'
        },
        {
          dimension: '回應速度',
          competitor: '被動等待報修，視人力排程',
          us: '24/7 主動監控，即時遠端支援'
        },
        {
          dimension: '系統規劃',
          competitor: '解決當下需求，缺乏擴展性',
          us: '前瞻性架構，預留 5-10 年增長空間'
        },
        {
          dimension: '責任歸屬',
          competitor: '多家廠商碎片化，責任歸屬模糊',
          us: '一站式全責，單一溝通窗口'
        }
      ]
    },
    footer: {
      tagline: '您的數位基石建築師',
      description: '專業 IT 綜合服務供應商，為企業打造堅實的數位基礎。',
      services: {
        title: '服務',
        cabling: '結構化佈線',
        infrastructure: 'IT 基礎設施',
        managed: '受管理服務'
      },
      solutions: {
        title: '解決方案',
        datacenter: '數據中心建置',
        security: '網路安全防護',
        cloud: '雲端整合服務'
      },
      company: {
        title: '關於',
        about: '公司簡介',
        cases: '成功案例',
        contact: '聯繫我們'
      },
      copyright: '© 2026 IBUS (HK) LTD. All rights reserved.'
    },
    contactCTA: {
      title: '別讓過時的基礎設施拖累您的發展速度',
      subtitle: '現在就聯繫我們的資深顧問，獲取免費 IT 現狀評估報告',
      contactInfo: {
        title: '聯絡資訊',
        address: '地址',
        addressValue: '香港上環皇后大道中346-348號金煌行13/F A室',
        phone: '電話',
        email: '電郵'
      },
      form: {
        title: '發送訊息',
        name: '姓名',
        namePlaceholder: '請輸入您的姓名',
        company: '公司名稱',
        companyPlaceholder: '請輸入公司名稱',
        email: '電子郵件',
        emailPlaceholder: 'your@email.com',
        phone: '聯絡電話',
        phonePlaceholder: '請輸入聯絡電話',
        service: '感興趣的服務',
        servicePlaceholder: '請選擇服務項目',
        serviceOptions: {
          cabling: '結構化佈線系統',
          infrastructure: 'IT 基礎設施規劃',
          managed: '全方位受管理 IT 服務',
          comprehensive: '綜合解決方案'
        },
        message: '需求說明',
        messagePlaceholder: '請簡述您的需求（限500字）',
        captcha: '我不是機器人',
        captchaError: '請先勾選「我不是機器人」以繼續提交。',
        submit: '立即獲取免費評估',
        submitting: '提交中...',
        successMessage: '感謝您的提交！我們會盡快與您聯繫。',
        errorMessage: '提交失敗，請稍後再試或直接聯繫我們。'
      },
      equipment: {
        server: '伺服器',
        router: '路由器',
        storage: '儲存系統',
        firewall: '防火牆',
        voip: 'VoIP 系統',
        cloud: '雲端整合'
      }
    },
    techAnalysis: {
      badge: 'TECH ANALYSIS',
      title: '技術深度分析',
      subtitle: '以數據與事實為基礎，協助企業理解各項技術方案的核心差異，做出最具價值的 IT 投資決策。',
      tabs: {
        ngfw: '新一代防火牆 (NGFW)',
        vm: '虛擬機器 (VM)',
        ippbx: 'IP PBX 通訊系統'
      },
      ngfw: {
        title: '新一代防火牆 (NGFW) 技術對比',
        subtitle: '深度解析 NGFW、傳統防火牆與 UTM 三者的核心差異，協助企業做出最佳安全投資決策。',
        col1: '比較維度',
        col2: '傳統防火牆',
        col3: 'UTM 統一威脅管理',
        col4: '新一代防火牆 NGFW',
        tip: 'IBUS 建議：對於現代企業環境，NGFW 是唯一能有效應對進階持續性威脅（APT）的防火牆架構。我們提供 Fortinet、Palo Alto Networks 等頂級品牌的選型、部署及後續管理服務。',
        rows: [
          { dimension: '封包檢測深度', traditional: '僅檢查 IP / Port（第3-4層）', utm: '整合多功能，但效能瓶頸明顯', ngfw: '深度封包檢測（DPI）至第7層應用層' },
          { dimension: '應用識別能力', traditional: '無法識別應用程式', utm: '基本應用識別，特徵庫更新較慢', ngfw: '識別 6,000+ 應用，即時更新威脅情報' },
          { dimension: '用戶身份管控', traditional: '僅基於 IP 位址控制', utm: '有限的用戶識別', ngfw: '整合 AD/LDAP，以用戶身份為基礎制定策略' },
          { dimension: '加密流量檢測', traditional: '無法檢測 SSL/TLS 加密流量', utm: '部分支援，效能損耗大', ngfw: '全面 SSL 解密檢測，效能影響最小化' },
          { dimension: '威脅防護整合', traditional: '需獨立部署 IDS/IPS', utm: '功能整合但各模組獨立運作', ngfw: '原生整合 IPS、沙盒、威脅情報，統一引擎' },
          { dimension: '零信任支援', traditional: '不支援', utm: '有限支援', ngfw: '原生支援零信任網路存取（ZTNA）架構' },
          { dimension: '管理與可視性', traditional: '規則複雜，可視性低', utm: '統一介面，但報表功能有限', ngfw: '集中管理平台，完整流量可視化與日誌分析' }
        ]
      },
      vm: {
        title: '為什麼虛擬化是中小企業的最佳起點？',
        subtitle: '虛擬化技術是現代企業 IT 基礎設施的核心，以下為企業導入虛擬機器的四大核心優勢。',
        statLabels: ['平均硬體成本節省', '服務恢復時間 (RTO)', '伺服器整合比例'],
        statValues: ['50%', '< 60秒', '最高 20:1'],
        items: [
          { title: '資源整合，降低硬體成本', description: '單一實體伺服器可同時運行多台虛擬機器，大幅減少硬體採購數量。企業平均可節省 40–60% 的伺服器硬體開支，同時降低機房空間、電力及冷卻成本。' },
          { title: '快速部署與靈活擴展', description: '虛擬機器可在數分鐘內完成部署，相比實體伺服器的數天至數週大幅縮短。業務需求增長時，可即時分配更多資源，無需等待硬體採購。' },
          { title: '高可用性與災難恢復', description: '虛擬化平台內建高可用性（HA）機制，當實體主機故障時，虛擬機器可自動遷移至其他主機，業務中斷時間縮短至秒級。' },
          { title: '安全隔離與合規管理', description: '每台虛擬機器在獨立的沙盒環境中運行，即使一台虛擬機器受到攻擊，也不會影響其他虛擬機器，有效控制安全事件的爆炸半徑。' }
        ]
      },
      ippbx: {
        title: 'IP PBX 與 Keyline 通訊系統優勢對比',
        subtitle: '全面比較 IP PBX 與傳統 Keyline 按鍵電話系統，助您評估企業通訊系統升級的必要性與回報。',
        col1: '比較維度',
        col2: '傳統 Keyline 系統',
        col3: 'IP PBX 系統',
        tip: 'IBUS 建議：對於仍在使用 Keyline 系統的企業，升級至 IP PBX 的投資回報期通常在 12–18 個月內。我們提供完整的遷移方案，包括現有號碼保留、員工培訓及系統整合服務，確保零業務中斷切換。',
        rows: [
          { dimension: '初期建置成本', keyline: '硬體成本高，每線路需專用設備', ippbx: '軟體化架構，硬體成本大幅降低' },
          { dimension: '線路擴展彈性', keyline: '受限於實體線路數量，擴展需重新佈線', ippbx: '軟體授權擴展，數分鐘內增加分機' },
          { dimension: '通話費用', keyline: '依賴傳統電話線路，長途費用高昂', ippbx: '透過 SIP Trunk 大幅降低通話費，支援免費內部通話' },
          { dimension: '遠端辦公支援', keyline: '員工必須在辦公室使用實體電話', ippbx: '支援軟電話（Softphone），員工在任何地點均可接聽' },
          { dimension: '功能豐富度', keyline: '基本通話、轉接、保留功能', ippbx: '語音信箱轉Email、IVR、通話錄音、視訊會議、CRM整合' },
          { dimension: '系統維護', keyline: '需要專業技術人員現場維護', ippbx: '遠端管理，軟體更新自動化，維護成本低' },
          { dimension: '與IT系統整合', keyline: '獨立系統，難以與IT基礎設施整合', ippbx: '原生整合 CRM、ERP、Teams、Slack 等企業系統' },
          { dimension: '災難恢復能力', keyline: '實體設備損壞即導致通訊中斷', ippbx: '雲端備援，主機故障自動切換，業務不中斷' }
        ]
      },
      ctaText: '需要針對您的企業環境進行技術評估？',
      ctaBtn: '預約免費技術諮詢'
    },
    vmAdvantages: {
      title: '為什麼虛擬化是中小企業的最佳起點？',
      items: [
        { title: '資源利用率提升 70%', description: '一台實體伺服器可運行多個虛擬機，大幅降低硬體成本' },
        { title: '快速部署與測試', description: '幾分鐘內建立新環境，加速開發與上線流程' },
        { title: '簡化備份與還原', description: '透過快照功能，實現秒級備份與災難恢復' }
      ]
    },
    showcase: {
      title: '成功案例',
      subtitle: '我們為不同行業的客戶提供量身定制的解決方案',
      cta: '查看更多案例'
    }
  },
  en: {
    navbar: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      whyUs: 'Why Choose Us',
      showcase: 'Showcase',
      contact: 'Contact'
    },
    hero: {
      title: 'From Physical Infrastructure to Cloud Architecture',
      subtitle: 'Building Your Enterprise',
      highlight: 'Unbreakable Digital Foundation',
      description: 'We combine top-tier structured cabling engineering with forward-looking IT infrastructure planning, supported by round-the-clock managed services, ensuring your enterprise communications never go down and remain flexible for future growth.',
      cta: 'Book a Site Survey',
      learnMore: 'Explore Infrastructure Solutions'
    },
    about: {
      badge: 'ABOUT US',
      title: 'Craftsmanship at the Physical Layer,',
      titleItalic: 'Vision for the Digital Age',
      p1: 'We understand that strong enterprise growth starts with a solid foundation. As a leader in comprehensive IT services, we are not just a technology vendor — we are the architect of your digital foundation.',
      p2: 'We specialize in transforming complex structured cabling systems into efficient, organized, and manageable communication networks. From precise physical cable installation to strategic IT infrastructure planning and comprehensive managed IT services, we deliver end-to-end solutions.',
      whyTitle: 'Why Choose Us?',
      points: [
        { label: 'Engineering Excellence:', text: 'Strictly adhering to international cabling standards, ensuring every cable and cabinet performs at its best.' },
        { label: 'Forward Planning:', text: 'We don\'t just solve today\'s problems — we reserve space for your 5-10 year expansion.' },
        { label: 'Seamless Operations:', text: 'Through proactive monitoring, we eliminate issues before they occur.' }
      ],
      tags: ['Engineering Excellence', 'Forward Planning', 'Seamless Operations'],
      stats: {
        projects: 'Projects Completed',
        uptime: 'System Uptime',
        support: '24/7 Support'
      }
    },
    servicesSection: {
      badge: 'OUR SERVICES',
      title: 'Core Services',
      subtitle: 'Complete solutions from physical layer to application layer',
      items: [
        {
          title: 'Structured Cabling Systems',
          subtitle: 'The Physical Lifeline of Enterprise Communications',
          items: [
            'Cat6/6A & Fiber Optic Network Cabling Design & Installation',
            'Data Center Server Room Planning & Cable Management',
            'Wireless Access Point (AP) Deployment & Optimization',
            'Cabling System Testing Reports & Certification (Fluke Testing)'
          ]
        },
        {
          title: 'IT Infrastructure Planning',
          subtitle: 'Building a Stable, High-Performance Digital Environment',
          items: [
            'Server & Storage System Deployment',
            'Enterprise Network Architecture (Switch/Router/Firewall) Design',
            'Cloud & On-Premises Hybrid Architecture Integration',
            'Server Room Environment Monitoring & UPS Configuration',
            'VoIP System Architecture Deployment'
          ]
        },
        {
          title: 'Comprehensive Managed IT Services',
          subtitle: 'Your Dedicated External IT Department',
          items: [
            '7x24 Remote & On-Site Technical Support',
            'Proactive Network Security Monitoring & Threat Protection',
            'System Redundancy, Disaster Recovery (DR) & Data Backup Management',
            'Regular IT Asset Audits & Performance Optimization Recommendations'
          ]
        }
      ]
    },
    clientLogos: {
      title: 'Trusted Partners',
      subtitle: 'We provide professional services to leading enterprises across industries'
    },
    whyChooseUs: {
      title: 'Why Leading Enterprises Choose Us?',
      subtitle: 'We are not just a service provider, but the digital foundation for your business growth.',
      advantages: [
        {
          tag: 'Excellence',
          title: 'Rigorous Structured Standards',
          painPointLabel: 'Pain Point We See:',
          painPoint: 'Many IT companies only aim for "connectivity", resulting in messy server room cabling like spider webs, making future troubleshooting extremely difficult.',
          solutionLabel: 'Our Advantage:',
          solution: 'We insist on "craft-level cabling". Every cable is professionally tested and certified by Fluke, with complete labeling systems and digital topology diagrams. This means your server room is not only aesthetically pleasing but also enables instant fault location.'
        },
        {
          tag: 'Full Integration',
          title: 'From Physical to Application Layer',
          painPointLabel: 'Pain Point We See:',
          painPoint: 'One company for cabling, another for equipment, another for maintenance — when problems arise, everyone points fingers.',
          solutionLabel: 'Our Advantage:',
          solution: 'We provide one-stop IT solutions. From basic physical cabling, server architecture to managed operations, we take full responsibility. You only need one point of contact, and we handle all the complex technology.'
        },
        {
          tag: 'Proactive Operations',
          title: 'Solve Problems Before They Occur',
          painPointLabel: 'Pain Point We See:',
          painPoint: 'Traditional IT is "fix it when it breaks", leading to huge economic losses from business interruptions.',
          solutionLabel: 'Our Advantage:',
          solution: 'Our Managed IT Services use 24/7 proactive monitoring systems. We complete early warnings and resolutions before hardware overheating, network congestion, or security threats materialize, maintaining your system uptime above 99.9%.'
        },
        {
          tag: 'Future Ready',
          title: '5-10 Year Expansion Vision',
          painPointLabel: 'Pain Point We See:',
          painPoint: 'Poor infrastructure planning leads to complete rebuilds during business expansion, causing duplicate investments.',
          solutionLabel: 'Our Advantage:',
          solution: 'Our designs have high scalability. During initial planning, we reserve bandwidth margins and modular space, ensuring your IT architecture can smoothly upgrade as your company doubles in size.'
        }
      ]
    },
    comparisonTable: {
      title: 'Service Comparison',
      subtitle: 'See how we differ from typical IT contractors',
      headers: {
        dimension: 'Service Dimension',
        competitor: 'Typical IT Contractors',
        us: 'Our Professional Services'
      },
      rows: [
        {
          dimension: 'Cabling Standards',
          competitor: 'Just need connectivity, lack systematic labeling',
          us: 'International standard construction, certified reports provided'
        },
        {
          dimension: 'Response Speed',
          competitor: 'Passive waiting for repairs, depends on staffing',
          us: '24/7 proactive monitoring, instant remote support'
        },
        {
          dimension: 'System Planning',
          competitor: 'Solve current needs, lack scalability',
          us: 'Forward-looking architecture, 5-10 year growth space reserved'
        },
        {
          dimension: 'Accountability',
          competitor: 'Fragmented multiple vendors, unclear responsibility',
          us: 'One-stop full responsibility, single communication window'
        }
      ]
    },
    footer: {
      tagline: 'Your Digital Foundation Architect',
      description: 'Professional IT comprehensive service provider, building solid digital foundations for enterprises.',
      services: {
        title: 'Services',
        cabling: 'Structured Cabling',
        infrastructure: 'IT Infrastructure',
        managed: 'Managed Services'
      },
      solutions: {
        title: 'Solutions',
        datacenter: 'Data Center Construction',
        security: 'Network Security',
        cloud: 'Cloud Integration Services'
      },
      company: {
        title: 'About',
        about: 'Company Profile',
        cases: 'Success Stories',
        contact: 'Contact Us'
      },
      copyright: '© 2026 IBUS (HK) LTD. All rights reserved.'
    },
    contactCTA: {
      title: 'Don\'t Let Outdated Infrastructure Slow Down Your Growth',
      subtitle: 'Contact our senior consultants now for a free IT assessment report',
      contactInfo: {
        title: 'Contact Information',
        address: 'Address',
        addressValue: 'Room A, 13/F, Golden Crown Court, 346-348 Queen\'s Road Central, Sheung Wan, Hong Kong',
        phone: 'Phone',
        email: 'Email'
      },
      form: {
        title: 'Send Message',
        name: 'Name',
        namePlaceholder: 'Enter your name',
        company: 'Company Name',
        companyPlaceholder: 'Enter company name',
        email: 'Email',
        emailPlaceholder: 'your@email.com',
        phone: 'Phone',
        phonePlaceholder: 'Enter phone number',
        service: 'Service of Interest',
        servicePlaceholder: 'Select service',
        serviceOptions: {
          cabling: 'Structured Cabling System',
          infrastructure: 'IT Infrastructure Planning',
          managed: 'Comprehensive Managed IT Services',
          comprehensive: 'Comprehensive Solutions'
        },
        message: 'Requirements',
        messagePlaceholder: 'Briefly describe your needs (500 characters max)',
        captcha: 'I\'m not a robot',
        captchaError: 'Please check "I\'m not a robot" to continue.',
        submit: 'Get Free Assessment',
        submitting: 'Submitting...',
        successMessage: 'Thank you for your submission! We will contact you soon.',
        errorMessage: 'Submission failed. Please try again later or contact us directly.'
      },
      equipment: {
        server: 'Server',
        router: 'Router',
        storage: 'Storage',
        firewall: 'Firewall',
        voip: 'VoIP System',
        cloud: 'Cloud Integration'
      }
    },
    techAnalysis: {
      badge: 'TECH ANALYSIS',
      title: 'Technical Analysis',
      subtitle: 'Data-driven insights to help enterprises understand core differences between technology solutions and make the most valuable IT investment decisions.',
      tabs: {
        ngfw: 'Next-Gen Firewall (NGFW)',
        vm: 'Virtual Machine (VM)',
        ippbx: 'IP PBX Communication'
      },
      ngfw: {
        title: 'Next-Generation Firewall (NGFW) Technology Comparison',
        subtitle: 'In-depth analysis of NGFW, traditional firewalls, and UTM to help enterprises make the best security investment decisions.',
        col1: 'Dimension',
        col2: 'Traditional Firewall',
        col3: 'UTM (Unified Threat Management)',
        col4: 'Next-Gen Firewall (NGFW)',
        tip: 'IBUS Recommendation: For modern enterprise environments, NGFW is the only firewall architecture that can effectively counter Advanced Persistent Threats (APT). We provide selection, deployment, and ongoing management services for top brands including Fortinet and Palo Alto Networks.',
        rows: [
          { dimension: 'Packet Inspection Depth', traditional: 'Inspects IP/Port only (Layer 3-4)', utm: 'Multi-function integration, but performance bottlenecks', ngfw: 'Deep Packet Inspection (DPI) up to Layer 7 application layer' },
          { dimension: 'Application Identification', traditional: 'Cannot identify applications', utm: 'Basic app identification, slower signature updates', ngfw: 'Identifies 6,000+ apps with real-time threat intelligence' },
          { dimension: 'User Identity Control', traditional: 'IP address-based control only', utm: 'Limited user identification', ngfw: 'Integrates AD/LDAP, user identity-based policy enforcement' },
          { dimension: 'Encrypted Traffic Inspection', traditional: 'Cannot inspect SSL/TLS traffic', utm: 'Partial support, high performance overhead', ngfw: 'Full SSL decryption inspection with minimal performance impact' },
          { dimension: 'Threat Protection Integration', traditional: 'Requires separate IDS/IPS deployment', utm: 'Integrated but modules operate independently', ngfw: 'Native IPS, sandbox, threat intelligence with unified engine' },
          { dimension: 'Zero Trust Support', traditional: 'Not supported', utm: 'Limited support', ngfw: 'Native Zero Trust Network Access (ZTNA) architecture support' },
          { dimension: 'Management & Visibility', traditional: 'Complex rules, low visibility', utm: 'Unified interface, limited reporting', ngfw: 'Centralized management, full traffic visibility and log analysis' }
        ]
      },
      vm: {
        title: 'Why Virtualization is the Best Starting Point for SMEs?',
        subtitle: 'Virtualization technology is the core of modern enterprise IT infrastructure. Here are the four key advantages of implementing virtual machines.',
        statLabels: ['Average Hardware Cost Savings', 'Recovery Time (RTO)', 'Server Consolidation Ratio'],
        statValues: ['50%', '< 60s', 'Up to 20:1'],
        items: [
          { title: 'Resource Consolidation & Cost Reduction', description: 'A single physical server can run multiple virtual machines simultaneously, significantly reducing hardware procurement. Enterprises can save 40–60% on server hardware costs while reducing data center space, power, and cooling expenses.' },
          { title: 'Rapid Deployment & Flexible Scaling', description: 'Virtual machines can be deployed in minutes compared to days or weeks for physical servers. When business demands grow, resources can be allocated instantly without waiting for hardware procurement.' },
          { title: 'High Availability & Disaster Recovery', description: 'Virtualization platforms have built-in High Availability (HA) mechanisms. When a physical host fails, VMs automatically migrate to other hosts, reducing business interruption to seconds.' },
          { title: 'Security Isolation & Compliance Management', description: 'Each VM runs in an isolated sandbox environment. Even if one VM is compromised, it does not affect others, effectively containing the blast radius of security incidents.' }
        ]
      },
      ippbx: {
        title: 'IP PBX vs. Keyline Communication System Comparison',
        subtitle: 'Comprehensive comparison of IP PBX and traditional Keyline systems to help you evaluate the necessity and ROI of upgrading your enterprise communication system.',
        col1: 'Dimension',
        col2: 'Traditional Keyline System',
        col3: 'IP PBX System',
        tip: 'IBUS Recommendation: For enterprises still using Keyline systems, the ROI period for upgrading to IP PBX is typically within 12–18 months. We provide complete migration solutions including number porting, staff training, and system integration to ensure zero business interruption.',
        rows: [
          { dimension: 'Initial Setup Cost', keyline: 'High hardware cost, dedicated equipment per line', ippbx: 'Software-based architecture, significantly lower hardware cost' },
          { dimension: 'Line Expansion Flexibility', keyline: 'Limited by physical lines, expansion requires re-cabling', ippbx: 'Software license expansion, add extensions in minutes' },
          { dimension: 'Call Costs', keyline: 'Relies on traditional phone lines, high long-distance fees', ippbx: 'Significantly reduced costs via SIP Trunk, free internal calls' },
          { dimension: 'Remote Work Support', keyline: 'Staff must use physical phones in the office', ippbx: 'Supports Softphone, staff can answer calls from anywhere' },
          { dimension: 'Feature Richness', keyline: 'Basic calling, transfer, hold functions', ippbx: 'Voicemail-to-email, IVR, call recording, video conferencing, CRM integration' },
          { dimension: 'System Maintenance', keyline: 'Requires on-site maintenance by specialists', ippbx: 'Remote management, automated software updates, low maintenance cost' },
          { dimension: 'IT System Integration', keyline: 'Standalone system, difficult to integrate with IT infrastructure', ippbx: 'Native integration with CRM, ERP, Teams, Slack and other enterprise systems' },
          { dimension: 'Disaster Recovery', keyline: 'Physical device damage causes communication outage', ippbx: 'Cloud backup, automatic failover, business continuity guaranteed' }
        ]
      },
      ctaText: 'Need a technical assessment for your enterprise environment?',
      ctaBtn: 'Schedule Free Consultation'
    },
    vmAdvantages: {
      title: 'Why Virtualization is the Best Starting Point for SMEs?',
      items: [
        { title: '70% Resource Utilization Improvement', description: 'One physical server can run multiple VMs, significantly reducing hardware costs' },
        { title: 'Rapid Deployment & Testing', description: 'Create new environments in minutes, accelerating development and deployment' },
        { title: 'Simplified Backup & Restore', description: 'Achieve second-level backup and disaster recovery through snapshot features' }
      ]
    },
    showcase: {
      title: 'Project Showcase',
      subtitle: 'Real project cases showcasing our commitment to quality and professionalism in every project.',
      cta: 'Inquire About Projects'
    }
  }
};

export default translations;
